import moment from "moment"

export const determineIfCalendarDayIsLocked = (currentDate, targetDate) => {
  // Calculate the difference between the target date and the current date
  const fromNow = moment(currentDate).diff(targetDate, "days")
  // Determine if the target date is this year
  const isThisYear =
    moment(targetDate).format("YYYY") === moment(currentDate).format("YYYY")
  // Determine if the day is locked
  return !isThisYear || fromNow > 180
}
